<template>
    <div class="row home_work_container">
        <div class="row">
            <h6 class="col m12">Homework</h6>
            <div class="col m8">
                <input type="text" v-model="name" placeholder="Type your form name">
            </div>
            <div class="col m4 center">
                <br>
                <button class="btn darken-3 upload_btn" @click="chooseFile">Send</button>
            </div>
        </div>
        <div clas="row">
            <div class="col m12">
                <table>
                    <thead>
                        <th>No</th>
                        <th>File</th>
                        <th>Date</th>
                        <th>#</th>
                    </thead>
                    <tbody>
                    
                        <tr v-for="(item,index) in data" v-bind:key="item.id">
                            <td>{{ index+1 }}</td>
                            <td><a target="_blank" :href="item.full_path" >{{ item.name }}</a></td>
                            <td>{{ item.created_at }}</td>
                            <td>
                                <button class="btn red darken-3" @click="deleteData(item.id)">
                                    <i class="material-icons">delete</i>
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <input type="file" id="file1" style="display:none" @change="onFileChange">
        </div>
    </div>
</template>
<script>
import { createFormData } from '@/misc/CreateFormData.js';
export default {
    props:["data"],

    data()
    {
        return {
            name:"",
        }
    },
    methods: {
      chooseFile()
      {
        if (this.name)
        {
            document.getElementById("file1").click()
        }
        else 
        {
            alert("You have to give file name")
        }
      },
      onFileChange(e)
      {
          let file=e.target.files[0];
          this.$store.dispatch("uploadHomeWork",createFormData({
              file:file,
              name:this.name,
              subject_id:this.$route.params.id,
              course_id:this.$route.params.course_id
          }));
      },
      deleteData(id)
      {
          this.$store.dispatch("deleteHomeWork",createFormData({
              id:id
          }));
      }
    },
}
</script>
<style lang="scss" scoped>
    .home_work_container
    {
        margin-top:100px;
        padding-left:20px;
    }

    .upload_btn 
    {
        background:#e38b00 !important;
    }

    table th 
    {
        background:grey;
        color:white;
    }

    table td {
        border-bottom:2px dashed black !important;
    }

</style>